import { Controller } from "@hotwired/stimulus"
import tippy, {followCursor} from 'tippy.js/headless';

// Connects to data-controller="ui--tooltip"
export default class extends Controller {
  static targets = [ "tip", "trigger" ]

  connect() {
    this.tooltipInstance = null
    this.initTooltip()
  }

  initTooltip() {
    if (!this.hasTriggerTarget || !this.hasTipTarget) return
    if (this.tooltipInstance) return

    const tip = this.tipTarget
    this.tooltipInstance = tippy(this.triggerTarget, {
      followCursor: true,
      plugins: [followCursor],
      render(instance) {
        const popper = document.createElement('div');
        popper.appendChild(tip);
        return { popper };
      },
    });
  }

  tipTargetConnected() {
    this.initTooltip()
  }

  triggerTargetConnected() {
    this.initTooltip()
  }

  disconnect() {
    if (this.tooltipInstance) {
      this.tooltipInstance.destroy()
      this.tooltipInstance = null
    }
  }
}
